export default {
  id: 197,
  title: 'Target #197 - Crystal',
  url: 'https://cssbattle.dev/play/197',
  colors: ['#5F133F', '#F075B0', '#F7BED9'],
  solution:
    '<p a><p b><p c><style>p[a]::after,p[a]::before,p[b]::after,p[b]::before,p[c]::after,p[c]::before{content:"";position:absolute;border-style:solid;border-color:#f7bed9 #5f133f}body{background:#5f133f}p{position:fixed}p[a],p[b],p[c]{top:54;left:175;width:50;height:160;background:#f075b0}p[a]{transform:rotate3d(0,0,1,60deg)}p[b]{transform:rotate3d(0,0,1,-60deg)}p[c]{background:radial-gradient(circle,#f7bed9 25px,#f075b0 25px)}p[a]::before,p[b]::before,p[c]::before{top:-30;border-width:0 25px 30px}p[a]::after,p[b]::after,p[c]::after{bottom:-30;border-width:30px 25px 0',
}
